// Generated by packages/ui/scripts/build-app-sprite.mjs - do not edit manually
export const spriteUrl = '/sprite.a4995701f99c.svg' as const;
